import { config } from "../configs/config";
import { h } from "@/app/helpers";
import Axios from "axios";

export async function register(data, showMessage = false) {
    const response = await Axios({
        url: `${config.apiUrl}/v1/app/auth/register`,
        method: "post",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        data,
    });
    return h.api.handleApiResponse(response, showMessage);
}

export async function login(data, showMessage = false) {
    const response = await Axios({
        url: `${config.apiUrl}/v1/app/auth/login`,
        method: "post",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        data,
    });
    return h.api.handleApiResponse(response, showMessage);
}

export async function passwordReset(data, showMessage = false) {
    const response = await Axios({
        url: `${config.apiUrl}/v1/app/auth/password-reset`,
        method: "post",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        data,
    });
    return h.api.handleApiResponse(response, showMessage);
}

export async function saveNewPassword(data, showMessage = false) {
    const response = await Axios({
        url: `${config.apiUrl}/v1/app/auth/password-change`,
        method: "post",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        data,
    });
    return h.api.handleApiResponse(response, showMessage);
}
